// Small helpers used inside the Telepro Call List UI.

export function playDingSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.type = "sine";
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    osc.frequency.linearRampToValueAtTime(1320, ctx.currentTime + 0.12);
    gain.gain.setValueAtTime(0.001, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.2, ctx.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.35);
    osc.start();
    osc.stop(ctx.currentTime + 0.4);
  } catch { /* audio blocked by browser → silently no-op */ }
}

export function formatElapsed(seconds) {
  const m = Math.floor(seconds / 60).toString().padStart(2, "0");
  const s = (seconds % 60).toString().padStart(2, "0");
  return `${m}:${s}`;
}

export function buildFicheUrl(slug, code) {
  const base = typeof window !== "undefined" ? window.location.origin : "https://www.moncommerce68.fr";
  return `${base}/entreprise/${slug}${code ? `?ref=${encodeURIComponent(code)}` : ""}`;
}

export function isMobileDevice() {
  return typeof navigator !== "undefined" && /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
}

/**
 * Build the editable parts (subject + body) of the prospection email.
 * Kept separate from URL composition so the user can tweak the draft
 * inside the preview modal before we open Gmail.
 */
export function buildEmailDraft({ biz, telepro, contactName }) {
  const firstName = telepro?.first_name || "";
  const code = telepro?.code || "";
  const proEmail = telepro?.pro_email || telepro?.email || "";
  const businessName = biz?.name || "votre établissement";
  const ficheUrl = biz?.slug ? buildFicheUrl(biz.slug, code) : "https://www.moncommerce68.fr";
  const greeting = contactName ? `Bonjour ${contactName}` : `Bonjour`;
  const subject = `${businessName} — référencement Premium Haut-Rhin (14 j gratuits)`;
  const body =
`${greeting},

Je suis ${firstName}, conseiller partenaire pour MonCommerce68 — l'annuaire local du Haut-Rhin (68).
Je me permets de vous contacter au sujet de la visibilité de ${businessName} dans notre annuaire.

Votre fiche est déjà en ligne, vous pouvez la voir ici :
${ficheUrl}

→ Référencement Premium en haut des résultats de votre catégorie
→ Logo, photos, numéro affiché en direct (pas masqué)
→ Recommandations par email à vos clients existants
→ 14 jours OFFERTS sans carte bancaire — vous testez sans engagement

Nos tarifs (avec promo lancement -50 % la 1ʳᵉ année) :
• Premium : 14,99 €/mois → 7,50 €/mois la 1ʳᵉ année
• Premium IA : 29,99 €/mois → 15,00 €/mois la 1ʳᵉ année (avec outils IA : génération contenu, réponses avis, conseiller visibilité)

Si pas concluant après les 14 jours : 0 € payé, vous arrêtez en un clic.

Pour activer votre essai gratuit :
1. Ouvrez le lien de votre fiche ci-dessus
2. Cliquez sur « C’est mon entreprise » et créez votre compte
3. Mon code conseiller (${code}) est déjà pré-rempli

Je reste à votre disposition par email ou téléphone pour toute question.

Cordialement,
${firstName}
Conseiller MonCommerce68
${proEmail}`;
  return { subject, body };
}

/**
 * Gmail compose URL (tf=cm pattern — view=cm/fs=1 now often lands on the inbox).
 * /u/0/ = first signed-in account. encodeURIComponent keeps spaces as %20.
 */
export function buildGmailComposeUrl({ to, subject, body }) {
  const q = `to=${encodeURIComponent(to)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  return `https://mail.google.com/mail/u/0/?${q}&tf=cm`;
}

export function buildMailtoUrl({ to, subject, body }) {
  return `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
